import { Button, SIZE_BLOCK, STYLE_FILL } from '@eventbrite/eds-button';
import { gettext } from '@eventbrite/i18n';
import ButtonFromGoogle from '@google-pay/button-react';
import { GooglePayment } from 'braintree-web';
import React, { useEffect } from 'react';
import './GooglePayButton.scss';

interface GooglePayButtonProps {
    clearError: () => void;
    defaultLocale: string;
    environment: 'TEST' | 'PRODUCTION';
    handleOnCancel: () => void;
    handleOnClick: () => void;
    handleOnError: (e: google.payments.api.PaymentsError | Error) => void;
    handleOnLoadPaymentData: (
        paymentData: google.payments.api.PaymentData,
        instance: GooglePayment,
    ) => void;
    instance: GooglePayment;
    paymentRequest?: google.payments.api.PaymentDataRequest;
}

export const GooglePayButton: React.FunctionComponent<GooglePayButtonProps> = ({
    clearError,
    defaultLocale,
    environment,
    handleOnCancel,
    handleOnClick,
    handleOnError,
    handleOnLoadPaymentData,
    instance,
    paymentRequest,
}) => {
    useEffect(() => {
        return () => clearError();
    });

    const placeholderButton = (
        <div className="placeholder-button-wrapper">
            <Button
                data-testid="google-pay-button-placeholder"
                disabled={true}
                isLoading={true}
                size={SIZE_BLOCK}
                style={STYLE_FILL}
            >
                {gettext('Place Order')}
            </Button>
        </div>
    );

    const button = paymentRequest ? (
        <ButtonFromGoogle
            buttonLocale={defaultLocale}
            buttonType="buy"
            className="google-pay-button"
            environment={environment}
            onCancel={handleOnCancel}
            onClick={handleOnClick}
            onError={(e) => {
                handleOnError(e);
            }}
            onLoadPaymentData={(paymentData) => {
                handleOnLoadPaymentData(paymentData, instance);
            }}
            paymentRequest={paymentRequest}
        />
    ) : (
        placeholderButton
    );

    return <div className="google-pay-button-wrapper">{button}</div>;
};
